import { render, staticRenderFns } from "./OrdersDetails.vue?vue&type=template&id=7880a68a&scoped=true"
import script from "./OrdersDetails.vue?vue&type=script&lang=js"
export * from "./OrdersDetails.vue?vue&type=script&lang=js"
import style0 from "./OrdersDetails.vue?vue&type=style&index=0&id=7880a68a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7880a68a",
  null
  
)

export default component.exports